/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'delete': {
    width: 12,
    height: 14,
    viewBox: '0 0 12 14',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M5 0a1 1 0 00-1 1v1H0v1h1v9a2 2 0 002 2h6a2 2 0 002-2V3h1V2H8V1a1 1 0 00-1-1H5zM4 5h1v6H4V5zm4 0H7v6h1V5z" _fill="#006FBA"/>'
  }
})
